import { combineReducers } from 'redux';
import applicationReducer from './application-reducer';
import packageReducer from './packages-reducer';
import banners from './banner-reducer';
import section from './custom-section-reducer';
import forms from './forms-reducer';
import landingReducer from './landing-reducer';

const reducers = combineReducers({
  applicationState: applicationReducer,
  bannersState: banners,
  sectionState: section,
  packages: packageReducer,
  forms: forms,
  landing: landingReducer,
});

export default reducers;
